import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=43492f44"
import script from "./NewGroup.ts?vue&type=script&lang=ts&external"
export * from "./NewGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports